import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {ContractDto} from "../../../model/dto/entity/contract.dto";
import {ContractService} from "../../../service/api/contract.service";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {WidgetHelperButton} from "../../../../../core/shared/basic/widget-helper-button";
import {ObjectTypeService} from "../../../../../core/cc/service/api/object-type.service";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestComplex} from "../../../../../core/shared/dto/object/request/object-request-complex";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {ObjectRequestComplexNode} from "../../../../../core/shared/dto/object/request/object-request-complex-node";

//TODO: REVIEW


@Component({
    selector: 'cm-contract-inline-component',
    templateUrl: './cm-contract-inline-component.html',
    standalone: false
})
export class CmContractInlineComponent implements OnInit, OnChanges {

    @Input() objectIdentifier: ObjectIdentifier;
    @Input() dto?: ContractDto | any;
    @Input() importObjectContext: DtoImportObjectContext;
    @Input() size: string = 'M';
    icon: string;

    toolbarButtons: WidgetHelperButton[] = [
        {
            label: 'Open in background',
            icon: 'fa-regular fa-send-backward',
            display: true,
            action: 'background',
            tooltip: 'Open in background'
        },
        {
            label: 'Open in new window',
            icon: 'fa-regular fa-arrow-up-right-from-square',
            display: true,
            action: 'newWindow',
            tooltip: 'Open in new window'
        }
    ];

    initialized: boolean;
    busy: boolean;

    constructor(protected contractService: ContractService,
                protected objectService: ObjectTypeService,
                protected navigationService: MvsObjectNavigationService) {

    }

    ngOnInit() {
        this.initComponent();
    }

    initComponent() {
        this.icon = this.contractService.getObjectIcon();
        this.refreshComponent();

    }

    refreshComponent() {

        // if (!this.dto) {
        //     this.contractService.get(this.objectIdentifier.objectId, DtoImportObjectContext.createEmpty(), false).subscribe((res: ContractDto) => {
        //         this.dto = res;
        //         this.initialized = true;
        //     });
        // } else {
        //     this.initialized = true;
        // }

        // if (!this.dto) {

            const objectRequest = ObjectRequestList.createBasic(false, [FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)], []);
            objectRequest.objectRequestComplex = ObjectRequestComplex.build(true, false, ObjectRequestComplexNode.createSimpleAttributeNode('partner'));

            this.contractService.list(objectRequest).subscribe((res: DtoList<ContractDto>) => {
                this.dto = res.entries[0];
                this.initialized = true;
            }, error => {
                this.dto = null;
            });
        // } else {
        //     this.initialized = true;
        // }


    }

    ngOnChanges(changes: SimpleChanges) {

    }

    handleButtonClick(event: WidgetHelperButton) {
        const navigationEntry = MvsObjectNavigationEntry.createNavigationEntry(this.objectIdentifier.objectType, this.objectIdentifier.objectId, null, this.objectIdentifier.objectType, null, null, MvsObjectNavigationActionEnum.any);
        if (event.action == 'background') {
            this.navigationService.addOverlay(navigationEntry)
        } else if (event.action == 'newWindow') {
            this.navigationService.handleObjectNavigation(this.objectIdentifier, null, {openNewTab: true});
        }
    }

    handleClick() {
        const navigationEntry = MvsObjectNavigationEntry.createNavigationEntry(this.objectIdentifier.objectType, this.objectIdentifier.objectId, null, this.objectIdentifier.objectType, null, null, MvsObjectNavigationActionEnum.any);
        this.navigationService.addOverlay(navigationEntry)
    }
}
